const primary = {
  main: 'hsl(256, 49%, 47%)',
};

const secondary = {
  main: 'hsl(256, 49%, 67%)',
};

export const palette = {
  mode: 'dark',
  primary,
  secondary,
};
